import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginAsEmployeeQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['String']['input'];
}>;


export type LoginAsEmployeeQuery = { __typename?: 'Query', loginAsEmployee: { __typename?: 'AuthResponse', token: string, authTokenType: Types.AuthTokenType, user: { __typename?: 'AuthResponseUser', id: string, companyName?: string | null, authUserType: Types.AccountType }, shopLocation?: { __typename?: 'AuthResponseLocation', id: string, name: string } | null, employee?: { __typename?: 'AuthResponseEmployee', id: string, firstName?: string | null, lastName?: string | null } | null } };


export const LoginAsEmployeeDocument = gql`
    query LoginAsEmployee($employeeId: String!) {
  loginAsEmployee(employeeId: $employeeId) {
    user {
      id
      companyName
      authUserType
    }
    token
    authTokenType
    shopLocation {
      id
      name
    }
    employee {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useLoginAsEmployeeQuery__
 *
 * To run a query within a React component, call `useLoginAsEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAsEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAsEmployeeQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useLoginAsEmployeeQuery(baseOptions: Apollo.QueryHookOptions<LoginAsEmployeeQuery, LoginAsEmployeeQueryVariables> & ({ variables: LoginAsEmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginAsEmployeeQuery, LoginAsEmployeeQueryVariables>(LoginAsEmployeeDocument, options);
      }
export function useLoginAsEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAsEmployeeQuery, LoginAsEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginAsEmployeeQuery, LoginAsEmployeeQueryVariables>(LoginAsEmployeeDocument, options);
        }
export function useLoginAsEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginAsEmployeeQuery, LoginAsEmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginAsEmployeeQuery, LoginAsEmployeeQueryVariables>(LoginAsEmployeeDocument, options);
        }
export type LoginAsEmployeeQueryHookResult = ReturnType<typeof useLoginAsEmployeeQuery>;
export type LoginAsEmployeeLazyQueryHookResult = ReturnType<typeof useLoginAsEmployeeLazyQuery>;
export type LoginAsEmployeeSuspenseQueryHookResult = ReturnType<typeof useLoginAsEmployeeSuspenseQuery>;
export type LoginAsEmployeeQueryResult = Apollo.QueryResult<LoginAsEmployeeQuery, LoginAsEmployeeQueryVariables>;